import { Navigate } from "react-router-dom";

import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="auth-wrap">Laden...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
